import waitForAnalytics from './wait'

declare var window: any

export default function track(event: string, data: {}, options?: {}, callback?: () => void) {
  waitForAnalytics(() => window.analytics.track(`[BEHAVIOR] ${event}`, data, options, callback))
}
